import { Asset } from "@/models/asset";
import { ContextualContent } from "@/models/contextualcontent";

export interface IProgramContentType {
    uuid?: string | null;
    name?: string | null;
    status?: string | null;
    description?: string | null;
    type?: string | null;
    baselineAnswerRate?: string | "0";
    setup?: string | null;
    asset?: Asset | null;
    informContextualUuid?: string | null;
    notificationContextualUuid?: string | null;
    cleanNotificationContextualUuid?: string | null;
    cleanDistUuid?: string | null;
    pushDistUuid?: string | null;
    engageAssetUuid?: string | null;
    startDateTime?: string | Date;
    endDateTime?: string | Date;
    startNow?: boolean;
    pushDistUuidFromServer?: string | null;
    cleanDistUuidFromServer?: string | null;
    contextualContent?: ContextualContent | null;
}

export class ProgramContentType {
    public uuid!: string | null;
    public name!: string | null;
    public status!: string | null;
    public description!: string | null;
    public type!: string | null;
    public baselineAnswerRate?: string | "0";
    public setup!: string | null;
    public asset!: Asset | null;
    public informContextualUuid!: string | null;
    public contextualContent!: ContextualContent | null;
    public notificationContextualUuid!: string | null;
    public cleanNotificationContextualUuid!: string | null;
    public pushDistUuid!: string | null;
    public cleanDistUuid!: string | null;
    public engageAssetUuid!: string | null;
    public startDateTime!: string | Date;
    public endDateTime!: string | Date;
    public startNow!: boolean;
    public pushDistUuidFromServer?: string | null;
    public cleanDistUuidFromServer?: string | null;

    constructor(contentType: IProgramContentType) {
        if (!contentType) {
            throw new Error("Cannot construct ProgramContentType from falsey IProgramContentType");
        }

        this.uuid = contentType.uuid || null;
        this.name = contentType.name || null;
        this.status = contentType.status || "draft";
        this.description = contentType.description || null;
        this.type = contentType.type || null;
        this.baselineAnswerRate = contentType.baselineAnswerRate || "0";
        this.setup = contentType.setup || null;
        this.asset = contentType.asset || null;
        this.informContextualUuid = contentType.informContextualUuid || null;
        this.notificationContextualUuid = contentType.notificationContextualUuid || null;
        this.cleanNotificationContextualUuid = contentType.cleanNotificationContextualUuid || null;
        this.pushDistUuid = contentType.pushDistUuid || null;
        this.cleanDistUuid = contentType.cleanDistUuid || null;
        this.pushDistUuidFromServer = contentType.pushDistUuid || null;
        this.cleanDistUuidFromServer = contentType.cleanDistUuid || null;
        this.engageAssetUuid = contentType.engageAssetUuid || null;
        this.startDateTime =  contentType.startDateTime || new Date().toISOString().substr(0, 10);
        this.endDateTime = contentType.endDateTime || new Date().toISOString().substr(0, 10);
        this.startNow = contentType.startNow || false;
        this.contextualContent = contentType.contextualContent || null;
    }

    public static empty(type: string | null): ProgramContentType {
        var pct = new ProgramContentType({type: type});
        pct.description = "Initial Version";
        return pct;
    }

    public toNewInformProgramContentTypeDto(): IProgramContentType | any {
        return {
            name: this.name,
            informContextualUuid: this.informContextualUuid,
            description: this.description,
            type: this.type,
            baselineAnswerRate: this.baselineAnswerRate,
            status: this.status,
            startDateTime: this.startDateTime,
            endDateTime: this.endDateTime
        };
    }

    public toUpdateInformProgramContentTypeDto(): IProgramContentType | any {
        return {
            uuid: this.uuid,
            name: this.name,
            informContextualUuid: this.informContextualUuid,
            description: this.description,
            type: this.type,
            baselineAnswerRate: this.baselineAnswerRate,
            status: this.status,
            startDateTime: this.startDateTime,
            endDateTime: this.endDateTime
        };
    }


    public toNewEngageProgramContentTypeDto(): IProgramContentType | any {
        return {
            name: this.name,
            engageAssetUuid: this.engageAssetUuid,
            pushDistUuid: this.pushDistUuid,
            cleanDistUuid: this.cleanDistUuid,
            description: this.description,
            type: this.type,
            baselineAnswerRate: this.baselineAnswerRate,
            status: this.status
        };
    }

    public toUpdateEngageProgramContentTypeDto(): IProgramContentType | any {
        return {
            uuid: this.uuid,
            name: this.name,
            engageAssetUuid: this.engageAssetUuid,
            pushDistUuid: this.pushDistUuid,
            cleanDistUuid: this.cleanDistUuid,
            notificationContextualUuid: this.notificationContextualUuid,
            cleanNotificationContextualUuid: this.cleanNotificationContextualUuid,
            description: this.description,
            type: this.type,
            baselineAnswerRate: this.baselineAnswerRate,
            status: this.status
        };
    }

}
